const data = {};

data.template = `<div class="A4 water-mark water-mark-ie" style="padding-bottom: 20px;font-family: 'Cordia New';font-size: 26px;">
<div style="font-family: 'Cordia New';font-size: 26px;">
<div contenteditable="false" style="text-align: center;"><span style="text-align: left;" contenteditable="false"
        class="date">{date}</span></div>
<div>&nbsp;</div>
<div style="line-height: 1.5;"><span contenteditable="true">เรื่อง&nbsp;&nbsp;&nbsp;&nbsp;</span><span
        contenteditable="true">แจ้งสงวนสิทธิ์การเรียกค่าปรับ</span></div>
<div style="line-height: 1.5;"><span contenteditable="true">เรียน&nbsp;&nbsp;&nbsp;</span><span contenteditable="false"
        class="company_name">{company_name}</span></div>
<div style="line-height: 1.5;"><span contenteditable="true">อ้างถึง&nbsp;</span><span contenteditable="false"
        class="reference">หนังสือแจ้งสิทธิ์การเรียกค่าปรับ&nbsp;</span><span contenteditable="false"
        class="adjust_no">{adjust_no}</span><span contenteditable="false">&nbsp;ลงวันที่&nbsp;</span><span
        contenteditable="false" class="str_adjust_date_th">{str_adjust_date_th}</span></div>

<div>&nbsp;</div>
<div style="height: 450px;">
    <div style="line-height: 1.5;"><span style="padding-left: 80px;" contenteditable="true">ตามหนังสือที่อ้างถึง ได้แจ้งสิทธิ์การเรียกค่าปรับไว้นั้น
            และจะต้องมีการปรับตามสัญญาหรือข้อตกลง จึงขอสงวนสิทธิ์การเรียกค่าปรับตามสัญญาหรือข้อตกลง</span></div>
   
    <div>&nbsp;</div>
    <div><span style="padding-left: 80px;" contenteditable="true">จึงเรียนมาเพื่อโปรดทราบ</span></div>
</div>
<div>
    <div style="text-align: center;" contenteditable="true">ขอแสดงความนับถือ</div>
    <div style="text-align: center;" contenteditable="false">&nbsp;</div>
    <div style="text-align: center;" contenteditable="false">&nbsp;</div>
    <div style="text-align: center;" contenteditable="false" class="approver_name">{approver_name}</div>
    <div style="text-align: center;" contenteditable="true">{#approver_position}</div>
    <div style="text-align: center;" contenteditable="true">Electronically approved by Acceptance Committee</div>
</div>
<div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div style="text-align: left;" contenteditable="false" class="org_unit">{org_unit}</div>
    <div style="text-align: left;" contenteditable="false"><span>โทร. </span><span
            class="org_unit_tel">{org_unit_tel}</span></div>
</div>
</div></div>`;



export default data;